import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { jobDetailsPartConfig } from './config';

const JobDetailsPartStack = createStackNavigator();

const JobDetailsPartNavigator = () => {
  return (
    <JobDetailsPartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {jobDetailsPartConfig.map(({ Component, name }) => (
        <JobDetailsPartStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsPartStack.Navigator>
  );
};

export { JobDetailsPartNavigator };
